import { useEffect } from 'react';
import { AppDispatch } from '../../common/store';
import { useDispatch, useSelector } from 'react-redux';
import IDeal from '../../common/model/IDeal';
import currentDealSelectors from '../store/selectors/currentDealSelectors';
import { partExchangeActions } from '../store/reducers/partExchangeReducer';

const useFetchCurrentDeal = () => {
  const dispatch: AppDispatch = useDispatch();
  const plainDeal: IDeal = useSelector(currentDealSelectors.getCurrentDeal);

  useEffect(() => {
    if (plainDeal) {
      dispatch(partExchangeActions.setPartExchange(plainDeal.partExchange));
    }
  }, [plainDeal]);
};

export default useFetchCurrentDeal;
